import { createAction, props } from '@ngrx/store';
import { IMassiveUploadState, IUploadFileResult } from './massive-upload';
import { GenericResponse } from '../../interfaces/generic-response';

export const UPLOAD_FILE_MASSIVE = createAction(
  '[MASSIVE UPLOAD] - massive upload',
  props<{ payload: FormData }>()
);

export const UPLOAD_FILE_MASSIVE_ASSOCIATION = createAction(
  '[MASSIVE UPLOAD] - massive upload association',
  props<{ payload: FormData, category: string }>()
);

export const UPLOAD_FILE_MASSIVE_SUCCESS = createAction(
  '[MASSIVE UPLOAD] - massive upload success',
  props<{ uploadFileResult: IUploadFileResult | null }>()
);

export const UPLOAD_FILE_MASSIVE_DATA = createAction(
  '[MASSIVE UPLOAD] - massive upload data',
  props<{ payload: any }>()
);

export const UPLOAD_FILE_MASSIVE_DATA_ASSOCIATION = createAction(
  '[MASSIVE UPLOAD] - massive upload data association',
  props<{ payload: any }>()
);

export const UPLOAD_FILE_MASSIVE_UTILITY_DATA = createAction(
  '[MASSIVE UPLOAD] - massive upload utility data',
  props<{ payload: any, utilityType: string }>()
);

export const DOWNLOAD_PRECOMPILED_DOCUMENT_MASSIVE_UPLOAD = createAction(
  '[MASSIVE UPLOAD] - massive upload download precompiled',
  props<{ payload: any, code: string, isRecovery: boolean }>()
);

export const UPLOAD_FILE_MASSIVE_UTILITY = createAction(
  '[MASSIVE UPLOAD] - massive upload data utility',
  props<{ payload: FormData, utilityType: string }>()
);

export const UPLOAD_FILE_MASSIVE_DATA_SUCCESS = createAction(
  '[MASSIVE UPLOAD] - massive upload data success',
  props<{ uploadFileDataResult: GenericResponse | null }>()
);

export const RESET_MASSIVE_UPLOADS_STORE = createAction(
  '[MASSIVE UPLOAD] - reset massive upload store'
)
